import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'website';
const pagePrefix = 'admin';
const action = 'CustomPageButtonInteracted';

const actionProps = {
  action,
  category,
  pagePrefix,
};

const telemObject = createTelemetryObject({
  actions: {
    photoGalleryClicked: (page: string) => ({
      ...actionProps,
      page,
      label: 'Create Photo Gallery Clicked',
      extraInfo: {
        itemType: 'photoGallery',
      },
    }),
    createNewAlbumSuccess: (eventId: string, albumName: string) => ({
      ...actionProps,
      extraInfo: {
        name: 'createNewAlbumSuccess',
        eventId,
        albumName,
      },
    }),
  },
});

const { TelemetryProvider: WebsiteEditorPhotoGalleryTelemetryProvider, useTelemetry: useWebsiteEditorPhotoGalleryTelemetry } = createTelemetry(telemObject);

export { WebsiteEditorPhotoGalleryTelemetryProvider, useWebsiteEditorPhotoGalleryTelemetry };
